<template>
  <AreaPageContainer>
      <!-- Content wrapper with header and footer -->
      <AreaPageBody>
        <AreaHeader />

        <!-- Inner Content -->
        <div class="tw-p-10">
          <!-- Title -->
          <div>
            <h2 class="tw-font-georgia tw-font-bold tw-text-5xl">
              Tax Transition Plan
            </h2>
            <p class="tw-font-georgia tw-italic tw-text-lg">
              Charting the course to your ideal portfolios
            </p>
            <AdvisorCoreStripes />
          </div>

          <TaxTransitionIntro />

          <!-- Main -->
          <div class="tw-mt-10">
            <TaxFeatureComponent
              :long-term-rate="longTermRate"
              :short-term-rate="shortTermRate"
            />
          </div>


          <h3 class="tw-text-xl tw-font-bold tw-font-georgia">
            Understanding the table methodology
          </h3>
          <TaxTransitionMethodology />
        </div>

        <AreaFooter />

        <CheckupDisclaimer class="tw-mt-16">
          <TaxTransitionMethodology />
        </CheckupDisclaimer>
      </AreaPageBody>

      <!-- Settings Sidebar -->
      <AreaSidebar
      >
        <IncludeInPresentationToggle name="Tax Transition" />
        <SidebarInput
          v-model="longTermRate"
          label="Long Term Capital Gains Rate %"
          type="number"
          min="0"
          max="100"
          step="1"
        />
        <SidebarInput
          v-model="shortTermRate"
          label="Short Term Capital Gains Rate %"
          type="number"
          min="0"
          max="100"
          step="1"
        />
        <!-- <SpeakersNotes :notes="area?.explanation" /> -->
        <!-- <AIChat /> -->
      </AreaSidebar>
  </AreaPageContainer>
</template>


<script>
import TaxTransitionIntro from './TaxTransitionIntro.vue';
import TaxFeatureComponent from './TaxFeatureComponent.vue';
import TaxTransitionMethodology from './TaxTransitionMethodology.vue';

import AreaPageContainer from '@frontend/ui/features/checkup/components/analytics/shared/AreaPageContainer.vue';
import AreaPageBody from '@frontend/ui/features/checkup/components/analytics/shared/AreaPageBody.vue';
import AreaHeader from '@frontend/ui/features/checkup/components/analytics/shared/AreaHeader.vue';
import AdvisorCoreStripes from '@frontend/ui/features/checkup/components/AdvisorCoreStripes.vue';
import AreaSidebar from '@frontend/ui/features/checkup/components/sidebar/AreaSidebar.vue';
import IncludeInPresentationToggle from '@frontend/ui/features/checkup/components/sidebar/IncludeInPresentationToggle.vue';
import SidebarInput from '@frontend/ui/features/checkup/components/sidebar/SidebarInput.vue';
import AreaFooter from '@frontend/ui/features/checkup/components/analytics/shared/AreaFooter.vue';
import CheckupDisclaimer from '@frontend/ui/features/checkup/components/CheckupDisclaimer.vue';

import { mapStores } from 'pinia';
import { useAdvisorStore } from '@frontend/ui/stores/advisorStore';


export default {
  name: 'TaxTransitionArea',
  components: {
    TaxTransitionIntro,
    TaxFeatureComponent,
    TaxTransitionMethodology,
    AreaPageContainer,
    AreaPageBody,
    AreaHeader,
    AdvisorCoreStripes,
    AreaSidebar,
    IncludeInPresentationToggle,
    SidebarInput,
    AreaFooter,
    CheckupDisclaimer,
  },
  props: [/* Inputs */],
  data() {
    return {
      show: true,
      longTermRate: 20,
      shortTermRate: 38,
    };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
    ...mapStores(useAdvisorStore),
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {},
};
</script>


<style scoped>
  .page {
    max-width: 70em;
    margin: auto;
    margin-top: 3em;
    background-color: white;
    border: 1px solid grey;
    padding: 3em;
  }
  .textcolumns {
    column-count: 2;
    column-width: 20em;
  }
</style>
